export default __webpack_public_path__ + "static/media/Screenshot3.4a6d3964.png";